import Adote from "paginas/Adote";
import Encontrados from "paginas/Encontrados";
import NaoEncontrada from "paginas/NaoEncontrada";
import PetFriendly from "paginas/PetFriendly";
import ProcuraSe from "paginas/ProcuraSe";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import FormDesaparecimento from "./paginas/FormDesaparecimento";
import Home from "./paginas/Home";
import PaginaBase from "./paginas/PaginaBase";






function AppRoutes(){
  return (    
    <BrowserRouter>    
        <Routes>
          <Route path="/" element={<PaginaBase />}>
            <Route index element={<Home />}></Route>
            {/* <Route path="contato" element={<Contato />}></Route> */}
            <Route path="procura-se" element={<ProcuraSe />}></Route>
            <Route path="encontrados" element={<Encontrados />}></Route>                    
            <Route path="adote" element={<Adote />}></Route>
            <Route path="petfriendly" element={<PetFriendly />}></Route>
            <Route path="formdesaparecimento" element={<FormDesaparecimento />}></Route>
          </Route>

          <Route path="*" element={<NaoEncontrada/>}></Route>
                       
        </Routes>      
    </BrowserRouter>
  )

}

export default AppRoutes;